import * as React from 'react';
import { Box, Grid, Button, TextField, Snackbar, Alert } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FormHelperText from '@mui/material/FormHelperText';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';


export const ProfileDetailsComp = (props) => {


    return (
        <Box>
            <Box className="form-head">
                <Grid container>
                    <Grid md={3}>
                        <Box>
                            <Button className='grey-theme-btn' variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => props.NavigateTo('profiles')}>
                                Back
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

            </Box>

            <Box style={{ marginTop: '20px' }}>
                <Grid container>
                    <Grid md={3}>
                        <Box p={2}>
                            <TextField className="text-input" id="txtProfileName" name='txtProfileName' disabled={props.mystate.mode == 'edit' ? true : false} error={props.mystate.txtProfileNameErr == '' ? false : true} helperText={props.mystate.txtProfileNameErr} onChange={(e) => props.HandleInputs(e, 'txtProfileName')} value={props.mystate.txtProfileName} label="Profile Name" variant="outlined" />
                        </Box>
                    </Grid>

                    <Grid md={3}>
                        <Box p={2}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Assigned Routes</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={props.mystate.ddlProfileAssignedRoutes}
                                    label="Assigned Routes"
                                    error={props.mystate.ddlProfileAssignedRoutesErr == '' ? false : true}
                                    multiple
                                    // helperText={props.mystate.ddlProfileAssignedRoutesErr}
                                    onChange={(e) => props.HandleInputs(e, 'ddlProfileAssignedRoutes')}
                                >
                                    <MenuItem value={'Users'}>{'Users'}</MenuItem>
                                    <MenuItem value={'Profiles'}>{'Profiles'}</MenuItem>
                                    <MenuItem value={'Dashboard'}>{'Dashboard'}</MenuItem>
                                    <MenuItem value={'Leads'}>{'Leads'}</MenuItem>
                                    <MenuItem value={'Institutes'}>{'Institutes'}</MenuItem>
                                    <MenuItem value={'Students'}>{'Students'}</MenuItem>
                                    <MenuItem value={'Agreements'}>{'Agreements'}</MenuItem>
                                    <MenuItem value={'Enquiry'}>{'Enquiry'}</MenuItem>
                                </Select>
                                <FormHelperText style={{ color: 'red' }}>{props.mystate.ddlProfileAssignedRoutesErr}</FormHelperText>
                            </FormControl>
                        </Box>
                    </Grid>

                    <Grid md={3}>
                        <Box p={2}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Assigned Lead Stages</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={props.mystate.ddlProfileAssignedLeadStages}
                                    label="Assigned Lead Stages"
                                    error={props.mystate.ddlProfileAssignedLeadStagesErr == '' ? false : true}
                                    multiple
                                    // helperText={props.mystate.ddlProfileAssignedLeadStagesErr}
                                    onChange={(e) => props.HandleInputs(e, 'ddlProfileAssignedLeadStages')}
                                >
                                    <MenuItem value={'Pending'}>{'Pending'}</MenuItem>
                                    <MenuItem value={'RNR'}>{'RNR'}</MenuItem>
                                    <MenuItem value={'Hold'}>{'Hold'}</MenuItem>
                                    <MenuItem value={'Dead'}>{'Dead'}</MenuItem>
                                    <MenuItem value={'Call Back'}>{'Call Back'}</MenuItem>
                                    <MenuItem value={'In Progress'}>{'In Progress'}</MenuItem>
                                    <MenuItem value={'S-Test'}>{'S-Test'}</MenuItem>
                                    <MenuItem value={'Test Completed'}>{'Test Completed'}</MenuItem>
                                    <MenuItem value={'Interview Scheduled'}>{'Interview Scheduled'}</MenuItem>
                                    <MenuItem value={'Interview Completed'}>{'Interview Completed'}</MenuItem>
                                    <MenuItem value={'Selected'}>{'Selected'}</MenuItem>
                                    <MenuItem value={'Rejected'}>{'Rejected'}</MenuItem>
                                    <MenuItem value={'Joined'}>{'Joined'}</MenuItem>
                                    <MenuItem value={'Not Joined'}>{'Not Joined'}</MenuItem>
                                    <MenuItem value={'Deferred Admission'}>{'Deferred Admission'}</MenuItem>
                                </Select>
                                <FormHelperText style={{ color: 'red' }}>{props.mystate.ddlProfileAssignedLeadStagesErr}</FormHelperText>
                            </FormControl>
                        </Box>
                    </Grid>

                    <Grid md={3}>
                        <Box p={2}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Assigned Deal Stages</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={props.mystate.ddlProfileAssignedDealStages}
                                    label="Assigned Booking Stages"
                                    multiple
                                    error={props.mystate.ddlProfileAssignedDealStagesErr == '' ? false : true}
                                    // helperText={props.mystate.ddlProfileAssignedDealStagesErr}
                                    onChange={(e) => props.HandleInputs(e, 'ddlProfileAssignedDealStages')}
                                >
                                    <MenuItem value={'Interview Pending'}>{'Interview Pending'}</MenuItem>
                                    <MenuItem value={'Interview Completed'}>{'Interview Completed'}</MenuItem>
                                    <MenuItem value={'Selected'}>{'Selected'}</MenuItem>
                                    <MenuItem value={'Rejected'}>{'Rejected'}</MenuItem>
                                    <MenuItem value={'Backed Out'}>{'Backed Out'}</MenuItem>
                                    <MenuItem value={'Onboard'}>{'Onboard'}</MenuItem>
                                    <MenuItem value={'Registration Completed'}>{'Registration Completed'}</MenuItem>
                                    <MenuItem value={'Attending Online Classes'}>{'Attending Online Classes'}</MenuItem>
                                    <MenuItem value={'On Hold'}>{'On Hold'}</MenuItem>
                                </Select>
                                <FormHelperText style={{ color: 'red' }}>{props.mystate.ddlProfileAssignedDealStagesErr}</FormHelperText>
                            </FormControl>
                        </Box>
                    </Grid>

                    <Grid md={3}>
                        <Box p={2}>
                            <TextField multiline rows={3} className="text-input" id="txtProfileDesc" name='txtProfileDesc' error={props.mystate.txtProfileDescErr == '' ? false : true} helperText={props.mystate.txtProfileDescErr} onChange={(e) => props.HandleInputs(e, 'txtProfileDesc')} value={props.mystate.txtProfileDesc} label="Profile Description" variant="outlined" />
                        </Box>
                    </Grid>

                    <Grid md={12}>
                        <Box mt={2} textAlign={'center'}>
                            {
                                props.mystate.mode == 'add' ?

                                    props.mystate.addProfile == true ?

                                        <LoadingButton
                                            loading
                                            loadingPosition="start"
                                            startIcon={<SaveIcon />}
                                            variant="outlined"
                                        >
                                            Add Profile
                                        </LoadingButton>
                                        :

                                        <Button className='grey-theme-btn' variant="outlined" onClick={() => props.AddProfile()}>Add New Profile</Button>
                                    :
                                    props.mystate.editProfile == true ?

                                        <LoadingButton
                                            loading
                                            loadingPosition="start"
                                            startIcon={<SaveIcon />}
                                            variant="outlined"
                                        >
                                            Update Profile
                                        </LoadingButton>
                                        :
                                        props.mystate.txtProfileName == '' ?
                                            ''
                                            :
                                            <Button className='grey-theme-btn' variant="outlined" onClick={() => props.AddProfile()}>Update Profile</Button>
                            }

                        </Box>
                    </Grid>
                </Grid>

            </Box>

            <Snackbar open={props.mystate.showAlert} autoHideDuration={3000} onClose={() => { props.HandleCloseAlertMsg(props.mystate.alertType) }}>
                <Alert
                    onClose={() => { props.HandleCloseAlertMsg(props.mystate.alertType) }}
                    severity={props.mystate.alertType}
                    variant="filled"
                    sx={{ width: '100%' }}

                >
                    {props.mystate.alertMsg}
                </Alert>
            </Snackbar>
        </Box>


    );
}